import React from "react";
import { MobileFiltersComponentProps } from "../../../../../utils/types";
import { getAllUniqueFilters, getFilterObjectWithParsedId } from "../../services";
import MobileFiltersButton from "./MobileFiltersButton";
import MobileFiltersModal from "./MobileFiltersModal";

const MobileFilters = ({
	setShowMobileFilters,
	selectedFilters,
	filters,
	showMobileFilters,
	onChangeFilters,
	onChangeColumns,
	segments,
	onChangeSegment,
	hasConfigSaveSegment,
	segmentModal,
	segment,
	onSaveSegment,
	maxDate,
	dateRangePickerCustomRanges,
	minDate,
	dateRangePickerCustomActions,
	onCreateSegment,
	setSegmentModal,
	selectedColumns,
	allColumns,
	shouldDisableSortingOfStickyColumns,
	isNumberOfStickyColumnsDynamic,
	customFields,
	columnsFields,
	stickyColumnsDividerPosition,
	onChangeStickyColumnsDividerPosition,
	setNumberOfActiveStickyColumns,
	numberOfActiveStickyColumns,
	defaultSelectedColumns,
	numberOfStickyColumnsAtTheStart,
	defaultSelectedColumnsOrder,
	isReport,
	defaultGroups,
	defaultGroupColumn,
	groupsFromConfig,
	stateColumns,
	defaultSort,
	selectedPageSize,
}: MobileFiltersComponentProps) => {
	const allUniqueParsedFilters = getAllUniqueFilters(filters).map(getFilterObjectWithParsedId);

	return (
		<>
			<MobileFiltersButton
				setShowMobileFilters={setShowMobileFilters}
				selectedFilters={selectedFilters}
				filters={allUniqueParsedFilters}
				selectedSegment={segment?.name}
			/>
			{showMobileFilters && (
				<MobileFiltersModal
					show={showMobileFilters}
					onHide={() => setShowMobileFilters(false)}
					onChangeFilters={onChangeFilters}
					selectedFilters={selectedFilters}
					allUniqueParsedFilters={allUniqueParsedFilters}
					segments={segments}
					onChangeSegment={onChangeSegment}
					hasConfigSaveSegment={hasConfigSaveSegment}
					segmentModal={segmentModal}
					segment={segment}
					onSaveSegment={onSaveSegment}
					maxDate={maxDate}
					minDate={minDate}
					dateRangePickerCustomRanges={dateRangePickerCustomRanges}
					dateRangePickerCustomActions={dateRangePickerCustomActions}
					onCreateSegment={onCreateSegment}
					setSegmentModal={setSegmentModal}
					selectedColumns={selectedColumns}
					allColumnsInOrder={allColumns}
					shouldDisableSortingOfStickyColumns={shouldDisableSortingOfStickyColumns}
					isNumberOfStickyColumnsDynamic={isNumberOfStickyColumnsDynamic}
					customFields={customFields}
					columnsFields={columnsFields}
					stickyColumnsDividerPosition={stickyColumnsDividerPosition}
					onChangeStickyColumnsDividerPosition={onChangeStickyColumnsDividerPosition}
					numberOfActiveStickyColumns={numberOfActiveStickyColumns}
					setNumberOfActiveStickyColumns={setNumberOfActiveStickyColumns}
					defaultSelectedColumns={defaultSelectedColumns}
					onChangeColumns={onChangeColumns}
					numberOfStickyColumnsAtTheStart={numberOfStickyColumnsAtTheStart}
					defaultSelectedColumnsOrder={defaultSelectedColumnsOrder}
					isReport={isReport}
					defaultGroups={defaultGroups}
					defaultGroupColumn={defaultGroupColumn}
					groupsFromConfig={groupsFromConfig}
					stateColumns={stateColumns}
					defaultSort={defaultSort}
					selectedPageSize={selectedPageSize}
				/>
			)}
		</>
	);
};

export default MobileFilters;
